var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #e63030;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit_Score",
    "data-name": "Credit Score"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,8.03C11.76,8.03,1,18.79,1,32.03s.21,3.68.62,5.46c.05.2.1.4.16.57.73,2.31,2.9,3.92,5.33,3.92h35.75c2.26,0,4.3-1.39,5.15-3.44.1-.2.19-.43.26-.68.02-.1.07-.26.13-.52.39-1.73.59-3.52.59-5.31,0-13.23-10.76-24-24-24h0ZM45.6,36.7c-.1.43-.13.53-.13.53v-.08c-.33,1.16-1.39,1.96-2.6,1.96H7.12c-1.2,0-2.26-.79-2.6-1.95l.02.13s-.03-.1-.11-.45c-.36-1.54-.55-3.15-.55-4.81,0-11.66,9.45-21.12,21.12-21.12s21.12,9.45,21.12,21.12c0,1.61-.18,3.17-.52,4.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.07,29.61c-.32-.17-.67-.29-1.04-.35-1.82-.29-3.54.95-3.83,2.78-.29,1.82.95,3.54,2.78,3.83,1.67.26,3.25-.76,3.72-2.33.04-.14.08-.29.11-.45.23-1.45-.51-2.83-1.74-3.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.81,22.07c-.24-.36-.76-.45-1.22-.21l-12.78,6.61c.25.08.48.17.71.3,1.4.74,2.26,2.18,2.29,3.72l10.74-9.2c.4-.34.51-.86.26-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.91,18.15c.52.3,1.18.12,1.48-.4.3-.52.12-1.18-.4-1.49-.52-.3-1.19-.12-1.49.4-.3.52-.12,1.19.4,1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3,16.11c.6,0,1.09-.49,1.09-1.09s-.49-1.09-1.09-1.09-1.09.49-1.09,1.09.49,1.09,1.09,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.14,31.08c-.63,0-1.15.51-1.15,1.15s.52,1.15,1.15,1.15,1.15-.51,1.15-1.15-.51-1.15-1.15-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.73,22.23c-.52-.3-1.19-.12-1.49.4-.3.52-.12,1.18.4,1.49.52.3,1.19.12,1.49-.4.3-.52.12-1.19-.4-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.61,16.27c-.52.3-.7.97-.4,1.49.3.52.97.7,1.48.4.52-.3.7-.97.4-1.49-.3-.52-.97-.7-1.49-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,32.41c.6,0,1.09-.49,1.09-1.09s-.49-1.09-1.09-1.09-1.09.49-1.09,1.09.49,1.09,1.09,1.09Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50,
    height: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScore);
export default __webpack_public_path__ + "static/media/credit-score.8ea9576028af21f785c0d1b60ef5a406.svg";
export { ForwardRef as ReactComponent };